/// <amd-module name="Feed/Legacy/Protocols/Npm/NpmOverviewAttributesPanel" />
import * as React from "react";

import { Provenance } from "Feed/Common/Contracts/Feed";
import * as PackageResources from "Feed/Common/Resources";
import { IPackageDetailsProps } from "Feed/Legacy/Protocols/Common/IPackageDetailsProps";
import { PackageDependencies } from "Feed/Legacy/Protocols/Components/PackageDependencies";
import { IProjectAttribute, PackageDevelopment } from "Feed/Legacy/Protocols/Components/PackageDevelopment";
import { PackageProvenance } from "Feed/Legacy/Protocols/Components/PackageProvenance";
import { PackageStats } from "Feed/Legacy/Protocols/Components/PackageStats";
import { PackageTags } from "Feed/Legacy/Protocols/Components/PackageTags";
import { NpmCiConstants } from "Feed/Legacy/Protocols/Npm/Constants/NpmConstants";
import { NpmProtocolMetadata } from "Feed/Legacy/Protocols/Npm/NpmContracts";
import { NpmDependencyHelper } from "Feed/Legacy/Protocols/Npm/NpmDependencyHelper";
import { NpmPackagePeople } from "Feed/Legacy/Protocols/Npm/NpmPackagePeople";

export interface INpmOverviewAttributesPanelState {
    provenance: Provenance;
}

export class NpmOverviewAttributesPanel extends React.Component<
    IPackageDetailsProps,
    INpmOverviewAttributesPanelState
> {
    public render(): JSX.Element {
        const npmMetadata: NpmProtocolMetadata =
            this.props.packageVersion.protocolMetadata && this.props.packageVersion.protocolMetadata.data
                ? (this.props.packageVersion.protocolMetadata.data as NpmProtocolMetadata)
                : null;
        const projectAttributes: IProjectAttribute[] = [];

        if (npmMetadata) {
            if (npmMetadata.homepage) {
                projectAttributes.push({
                    iconClass: "bowtie-icon bowtie-globe",
                    text: PackageResources.NpmHomepage_Title,
                    url: npmMetadata.homepage,
                    onClickCiFeature: NpmCiConstants.HomepageLinkClicked
                } as IProjectAttribute);
            }

            if (npmMetadata.bugs) {
                projectAttributes.push({
                    iconClass: "bowtie-icon bowtie-work-item-bug",
                    text: PackageResources.NpmBugs_Title,
                    url: npmMetadata.bugs.url ? npmMetadata.bugs.url : "mailto:" + npmMetadata.bugs.email,
                    onClickCiFeature: npmMetadata.bugs.url
                        ? NpmCiConstants.BugUrlLinkClicked
                        : NpmCiConstants.BugEmailLinkClicked
                } as IProjectAttribute);
            }

            if (npmMetadata.license) {
                projectAttributes.push({
                    iconClass: "bowtie-icon bowtie-script",
                    text: npmMetadata.license
                } as IProjectAttribute);
            }

            if (npmMetadata.main) {
                projectAttributes.push({
                    iconClass: "bowtie-icon bowtie-file-code",
                    text: npmMetadata.main
                } as IProjectAttribute);
            }
        }

        return (
            <div className="npm-overview-attributes-panel package-overview-attributes-panel">
                <PackageProvenance
                    pageContext={this.props.pageContext}
                    feed={this.props.feed}
                    packageId={this.props.packageSummary.id}
                    versionId={this.props.packageVersion.id}
                    publishDate={new Date(this.props.packageVersion.publishDate)}
                    isProvenanceEnabled={this.props.isProvenanceEnabled}
                    isProvenanceSupported={true}
                />
                <NpmPackagePeople
                    pageContext={this.props.pageContext}
                    author={npmMetadata ? npmMetadata.author : null}
                    contributors={npmMetadata ? npmMetadata.contributors : null}
                />
                <PackageDevelopment
                    pageContext={this.props.pageContext}
                    projectAttributes={projectAttributes}
                    packageSummary={this.props.packageSummary}
                    packageVersion={this.props.packageVersion}
                    upstreamSources={this.props.feed.project ? null : this.props.feed.upstreamSources}
                />
                {this.props.isMetricsEnabled && (
                    <PackageStats
                        packageVersionMetrics={this.props.packageVersionMetrics}
                        packageMetrics={this.props.packageMetrics}
                        isMetricsLoading={this.props.isMetricsLoading}
                        feed={this.props.feed}
                    />
                )}
                <PackageDependencies
                    pageContext={this.props.pageContext}
                    feed={this.props.feed}
                    packageSummary={this.props.packageSummary}
                    packageVersion={this.props.packageVersion}
                    dependencyHelperCallback={NpmDependencyHelper.formatGroupNames}
                    isSmartDependenciesEnabled={this.props.isSmartDependenciesEnabled}
                />
                <PackageTags tags={this.props.packageVersion.tags} title={PackageResources.PackageTags_Title_Npm} />
            </div>
        );
    }
}
